import { ListBox, ListBoxProps } from 'components/UI/ListBox';

const FormListSelectionBox = (props: ListBoxProps) => (
  <ListBox
    {...props}
    h="full"
    sx={{
      field: {
        h: 'full',
      },
    }}
    rootProps={{
      h: 'full',
    }}
  />
);

export default FormListSelectionBox;
